/**
 * Pret (Employee Loan) Types for HR Module
 */

export type StatutPret = 'EN_ATTENTE' | 'VALIDEE' | 'REFUSEE';

export interface EmployeeInfo {
  id: number;
  matricule: string;
  nom_complet: string;
  fonction: string | null;
  date_embauche: string | null;
  cin: string | null;
  adresse: string | null;
  nom_complet_ar?: string | null;
  lieu_naissance_ar?: string | null;
  adresse_ar?: string | null;
}

export interface ValidatorInfo {
  id: number;
  email: string;
  name: string | null;
}

export interface Pret {
  id: number;
  ref_pret: string | null;
  employee_id: number;
  employee: EmployeeInfo | null;
  montant_pret: number;
  prelevement_mensuel: number;
  duree_mois: number;
  montant_rembourse: number;
  montant_restant: number;
  mois_restants: number | null;
  pourcentage_rembourse: number;
  date_demande: string;
  date_debut_prelevement: string | null;
  date_fin_prevue: string | null;
  motif: string | null;
  statut: StatutPret;
  validated_by: number | null;
  validator: ValidatorInfo | null;
  validated_at: string | null;
  commentaire: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface PretCreate {
  employee_id: number;
  montant_pret: number;
  prelevement_mensuel: number;
  date_demande: string;
  date_debut_prelevement?: string | null;
  motif?: string | null;
}

export interface PretUpdate {
  montant_pret?: number;
  prelevement_mensuel?: number;
  date_demande?: string;
  date_debut_prelevement?: string | null;
  motif?: string | null;
}

export interface PretValidate {
  statut: StatutPret;
  commentaire?: string | null;
  date_debut_prelevement?: string | null;
}

export interface PretAddPayment {
  montant: number;
}

export interface PretListResponse {
  items: Pret[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface PretStats {
  total_demandes: number;
  total_en_attente: number;
  total_validees: number;
  total_refusees: number;
  total_montant_prete: number;
  total_montant_rembourse: number;
  total_montant_restant: number;
}

// Constants for dropdowns
export const STATUT_PRET_OPTIONS: { value: StatutPret; label: string; color: string }[] = [
  { value: 'EN_ATTENTE', label: 'En attente', color: 'warning' },
  { value: 'VALIDEE', label: 'Validé', color: 'success' },
  { value: 'REFUSEE', label: 'Refusé', color: 'error' },
];

export const getStatutPretLabel = (statut: StatutPret): string => {
  const option = STATUT_PRET_OPTIONS.find(o => o.value === statut);
  return option?.label || statut;
};

export const getStatutPretColor = (statut: StatutPret): 'warning' | 'success' | 'error' | 'default' => {
  const option = STATUT_PRET_OPTIONS.find(o => o.value === statut);
  return (option?.color as 'warning' | 'success' | 'error') || 'default';
};

// Payment history types
export interface PretPaiement {
  id: number;
  pret_id: number;
  montant: number;
  date_paiement: string;
  note: string | null;
  created_by: number | null;
  creator: {
    id: number;
    email: string;
    name: string | null;
  } | null;
  created_at: string;
}

export interface PretHistoriqueResponse {
  pret: Pret;
  paiements: PretPaiement[];
  total_paiements: number;
}
